import { createSelector } from "reselect";
import { path, prop, identity } from "ramda";

import { isUIComponentVisible } from "~/utils";

// Selectors
const getHeader = path(["domain", "ui", "header"]);
export const selectHeader = createSelector(getHeader, identity);
export const selectIsHeaderVisible = createSelector(
  getHeader,
  isUIComponentVisible
);

export const selectShowLeftSidebarSwitch = createSelector(
  getHeader,
  prop("showLeftSidebarSwitch")
);

export const selectShowRightSidebarSwitch = createSelector(
  getHeader,
  prop("showRightSidebarSwitch")
);

export const selectShowNextPageSwitch = createSelector(
  getHeader,
  prop("showNextPageSwitch")
);

export const selectShowGoToPageField = createSelector(
  getHeader,
  prop("showGoToPageField")
);

export const selectShowPreviousPageSwitch = createSelector(
  getHeader,
  prop("showPreviousPageSwitch")
);

export const selectShowEditableSwitch = createSelector(
  getHeader,
  prop("showEditableSwitch")
);

export const selectIntegrateMenu = createSelector(
  getHeader,
  prop("integrateMenu")
);

export const selectShowDisplayModeSwitch = createSelector(
  getHeader,
  prop("showDisplayModeSwitch")
);

// Initial State
const initialState = () => ({
  showLeftSidebarSwitch: true,
  showRightSidebarSwitch: true,
  showNextPageSwitch: true,
  showGoToPageField: true,
  showPreviousPageSwitch: true,
  integrateMenu: false,
  showDisplayModeSwitch: true
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
